import {SAVE_PRODUCT, UPDATE_PRODUCT_SELECTIONS} from "../mutation-types";
import ProductGroupHelper from "../../helper/ProductGroupHelper";

// initial state
const state = {
	activeProductSelections: [],
	rootProductId: null
};

// getters
const getters = {
	activeProductSelections: state => state.activeProductSelections,
	rootProductId: state => state.rootProductId,
	productInfo: (state, getters) => {
		if(!state.rootProductId) {
			return null;
		}
		const mainProduct = getters.productCatalog.getProduct(state.rootProductId);
		const mainGroup = mainProduct.groups.find(group => ProductGroupHelper.isMainProductGroup(group));
		const subProduct = mainGroup ? ProductGroupHelper.getSubProduct(mainGroup) : undefined;
		return {mainProduct, mainGroup, subProduct};
	},
	groupsWithMandatoryProductSelection: (state, getters) => {
		const productObj = getters.productInfo;
		if(!productObj) {
			return {};
		}

		return {};
	},
	groupsWithMissingSelections: (state, getters) => {
		if(state.activeProductSelections.length) {
			const productObj = getters.productInfo;
			if(!productObj) {
				return {};
			}
			const groupsWithMandatoryProductSelection = getters.groupsWithMandatoryProductSelection;

			return state.activeProductSelections.map(ps => {
				const findMainGroupInSelection = () => {
					return productObj.mainGroup ? ps.groups.find(group => {
						const groupId = group.groupId ? group.groupId : group.id;
						return groupId === productObj.mainGroup.id;
					}) : null;
				};
				const mainSelectionGroup = findMainGroupInSelection();
				const mainProductSelection = productObj.subProduct ? (mainSelectionGroup ? mainSelectionGroup.selectedProducts[0] : null) : ps;
				return mainProductSelection ? mainProductSelection.groups.filter(group => {
					const groupId = group.groupId ? group.groupId : group.id;
					const isMandatoryGroup = groupsWithMandatoryProductSelection[groupId];
					return isMandatoryGroup ? !group.selectedProducts.length : false;
				}) : [];
			});
		}
		return [];
	}
};

// actions
const actions = {

};

// mutations
const mutations = {
	[UPDATE_PRODUCT_SELECTIONS] (state, changedProductSelection) {
		state.activeProductSelections = changedProductSelection;
	},
	[SAVE_PRODUCT] (state, product) {
		state.rootProductId = product;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
